import styled from "styled-components";
import {LobbyHeaderDefaultBox} from "./lobby-header.default.box";
export const LobbyHeaderWsopBox = styled(LobbyHeaderDefaultBox)`
    background-color: #00000099;
`